<template lang="pug">
.banner.bg-cover.visible-xs
section.pt0
  .container
    .row
      //- filter-table(':data'="data", ':tabs'="tabs", ':tab.sync'="tab")
      filter-table(':tabs_url'="tabs_url", ':url'="url")
</template>

<script>
import FilterTable from './../filter-table.vue'
// let tabs = [ "2016", "2015", "2014", "2013", "2012", ]
//
// let data  = {
//   "2016": require('./../../data/news/financial/2016.json'),
//   "2015": require('./../../data/news/financial/2015.json'),
//   "2014": require('./../../data/news/financial/2014.json'),
//   "2013": require('./../../data/news/financial/2013.json'),
//   "2012": require('./../../data/news/financial/2012.json'),
// }


export default {
  data () {
    return {
      tabs_url: '/api/articles/financial_report/years',
      url: '/api/articles/financial_report'
    }
  },
  ready () {},
  methods: {},
  components: {
    'filter-table': FilterTable,
  }
}
</script>

<style lang="scss" scoped>
@import "global";

.banner {
  background-image: url('../../images/news/2-3_3_News_Fin_report.jpg');
  @media(max-width: #{$screen-xs-max}) {
    margin-bottom: 0;
    height: 166px;
  }
}
.container {
  @media(max-width: #{$screen-xs-max}) {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// financial.vue?c99d946e